export default "__VITE_ASSET__Ckn0cFfz__"